(function($, App, Utils, Components){
  "use strict";
	
  var logger = new Logger("ValassisGalleryComponent");

  Components.create('ValassisGalleryComponent', {

    Selectors: {
      GalleryWrapper: '.valassis-gallery-wrapper'
	},
	
	saveAndHideConsumerData: function() {
	  var _this = this;
	  var $galleryWrapper = $(_this.Selectors.GalleryWrapper);
	  _this.consumerData = $galleryWrapper.data('consumer-data');
	  $galleryWrapper.removeAttr('data-consumer-data');
	},
	
	showError: function(errorMsg) {
		$('[data-modal="true"]:not([data-id="loyal-guru-modal"])').trigger('click');
	},

    init: function() {
      this.saveAndHideConsumerData();
    }

  });

})(jQuery, window.App, window.App.Utils, window.App.Components);
